module.exports = __webpack_public_path__ + "WF.png?12bfd413095908333c89f5d5f7c6ede2";